export default defineNuxtPlugin(() => {
  const { $site } = useNuxtApp()

  // Google analytics integration
  if ($site.integrations) {
    const integration = $site.integrations['1d8fbf495ebabf8c5cad1a8c2bf97662']
    const trackingID = integration && integration.data && integration.enabled ? integration.data.trackingID : null

    if (trackingID) {
      if (import.meta.client && $site.isEmbed) {
        const { gtag } = useRuntimeConfig().public

        // Register the config before Cookie.vue creates its consent-gated initializer.
        gtag.tags = [
          ...gtag.tags.filter(tag => (typeof tag === 'string' ? tag : tag.id) !== trackingID),
          { id: trackingID, config: { cookie_flags: 'SameSite=None;Secure' } }
        ]
      }

      // Cookie.vue initializes Google Analytics after explicit consent.
      useState('gtagTrackingID', () => trackingID)
    }
  }
})
